import Menu from './Menu'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getOrderSummary } from '../../store/effects/order'
import { getMenu } from '../../store/effects/public'

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getOrderSummary, getMenu }, dispatch)

export default connect(null, mapDispatchToProps)(Menu)



// WEBPACK FOOTER //
// ./src/modules/Menu/index.js